import * as userTokenRequests from "../../api/userTokenRequest";
import {START_LOAD, FINISH_LOAD} from "../reducers/events";
import {push} from "./message";


const startLoading = () => {
    return {type: START_LOAD};
};
const finishLoading = (events) => {
    return {type: FINISH_LOAD, payload: events};
};

export const getEvents = () => {
    return dispatch => {
        dispatch(startLoading());
        userTokenRequests.getEventsList()
            .then(events => {
                dispatch(finishLoading(events))
            })
            .catch(error => {
                dispatch(finishLoading(null));
                dispatch(push(error.message))
            })
    }
};
export const getComingEvents = () => {
    return dispatch => {
        dispatch(startLoading());
        userTokenRequests.getComingEvents()
            .then(events => {
                dispatch(finishLoading(events))
            })
            .catch(error => {
                dispatch(finishLoading(null));
                dispatch(push(error.message))
            })
    }
};
